var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaBarsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 28 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.537,
    height: 2.528,
    rx: 1.264,
    transform: "matrix(-1 0 0 1 27.537 0)",
    fill: "#3C4043"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 27.537,
    height: 2.528,
    rx: 1.264,
    transform: "matrix(-1 0 0 1 27.537 7.078)",
    fill: "#3C4043"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 19.156,
    height: 2.528,
    rx: 1.264,
    transform: "matrix(-1 0 0 1 19.156 14.463)",
    fill: "#3C4043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaBarsIcon);
export default __webpack_public_path__ + "static/media/fa-bars-icon.97920ae3683925fdbb60dbcbbd1800e2.svg";
export { ForwardRef as ReactComponent };